export default "__VITE_ASSET__CNa$O$P0__"